import type { Shortcut, ShortcutDetail } from "./types";

export const isShortcut = (
  shortcut: Shortcut | ShortcutDetail,
): shortcut is Shortcut => {
  return (
    "id" in shortcut &&
    typeof shortcut.id === "string" &&
    shortcut.id.length > 0
  );
};
